import { observer } from 'mobx-react-lite';

import { AppPage } from 'app/common/app-page/features/app-page/app-page';

import { ProfileEntityGrid } from '../features/profile-entity-grid';

export const AllProfilesPage = observer(() => {
  return (
    <AppPage perm="PERM_TERMINAL_PROFILE_READ" noWrapper>
      <ProfileEntityGrid />
    </AppPage>
  );
});
